import React from 'react'
import { IonPage, IonFooter, IonToolbar, IonRow, IonCol, IonLabel } from '@ionic/react'
import { useHistory } from 'react-router'
import { useTranslation } from 'react-i18next'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import HeaderNav from '../../../components/headerNav/HeaderNav.component'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import AccordionList from '../components/AccordionList.component'
import './NemsisCustomData.page.css'

const NemsisCustomDataPage: React.FC = () => {
  const history = useHistory()
  const { t } = useTranslation()

  const onBackClick = () => {
    history.push(TabConstants.CHART_ROUTE)
  }

  return (
    <IonPage id='NemsisDataPage'>
      <PCRHeader />
      <HeaderNav
        prevOnClick={onBackClick}
        prevLabel={t('common.buttons.Back')}
        isBackButton
        nextLabel={t('common.buttons.Save')}
        title={t('fullChart.dispatch.NemsisData')}
      />
      <AccordionList />
      <IonFooter>
        <IonToolbar color='light' className='p-10'>
          <IonRow>
            <IonCol size='7'>
              <div className='label-container'>
                <IonLabel className='fw-700'>
                  <span className='nemsis-data-required-state required mr-8'></span>
                  {t('customStateElement.RequiredForPCR')}
                </IonLabel>
              </div>
            </IonCol>
            <IonCol size='5'>
              <div className='label-container'>
                <IonLabel className='fw-700'>
                  <span className='nemsis-data-required-state not-required mr-8'></span>
                  {t('customStateElement.NotRequired')}
                </IonLabel>
              </div>
            </IonCol>
          </IonRow>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  )
}

export default NemsisCustomDataPage
